<template>
  <div class="login examinerbg">
    <TopNavBar navtitle="考官登录"></TopNavBar>
    <div class="logoimg">
      <img src="../assets/gzmalogo.png" alt="">
       <van-icon class="iconfont" class-prefix='icon' name='icon-biaoqian' />     
    </div>
    <div class="login-box">
        <van-form @submit="onSubmit">
          <van-field
            v-model="username"
            name="username"
            left-icon="manager"
            label=" "
            placeholder="请填写手机号"
          />
          <van-field
            v-model="password"
            type="password"
            name="password"
            label=" "
            left-icon="lock"
            placeholder="请填写密码"
          />
          <div>
            <van-button round block type="info" native-type="submit">
               <img src="../assets/loginuser.png" width="25px" alt="">点击登录
            </van-button>
          </div>
        </van-form>

    </div>
    <copyright />
  </div>
</template>

<script>
import copyright from '@/components/copyright.vue'
import TopNavBar from '@/components/TopNavBar.vue'
export default {
    components:{
        TopNavBar,
        copyright
    },
   data() {
    return {
      username: '',
      password: '',
    };
  },
  methods: {
    onSubmit(values) {
      if(values.username===''){
        this.$toast.fail({message:'请输入手机号',});
        return;
      }
      if(values.password===''){
        this.$toast.fail({message:'请输入密码',});
        return;
      }
       this.$store
            .dispatch('Login', values)
            .then(() => {
               this.$toast.success({message:'登录成功',});
              this.$router.push({ path: '/VipCenter' });
            });
    },
  },
}
</script>
<style>
#app .examinerbg{
    background: url(../assets/examinerbg.jpg) #15171d no-repeat top;
}
#app .copyright p, #app .copyright p a{color: #dfdfdf;}
</style>
